import { createSlice } from '@reduxjs/toolkit';
var width = window.innerWidth < 768;
const initialState = {
    isSidebarshow:width ? true : false,
    location:'',
    Notification:[]
  };

  export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        sidebarAction: (state, action) => {
          console.log("reducer", action.payload)
        state.isSidebarshow = action.payload;
    },
      getlocationAction: (state, action) => {
       
        state.location = action.payload;
    },
    NotificationAction: (state, action) => {
      state.Notification = action.payload;
  },
}
  })

  export const { sidebarAction, getlocationAction, NotificationAction } = sidebarSlice.actions

  export default sidebarSlice.reducer;